var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActionChain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 427322804"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 25938",
    d: "M9.85833 12H11.7C12.5837 12 13.3 11.2837 13.3 10.4V4.1C13.3 3.21634 12.5837 2.5 11.7 2.5H3.1C2.21634 2.5 1.5 3.21634 1.5 4.1V10.4C1.5 11.2837 2.21634 12 3.1 12H3.76923",
    stroke: "#2CABF4",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 25939",
    d: "M11.1251 8H8.30012C7.41647 8 6.70012 8.71634 6.70012 9.6V15.9C6.70012 16.7837 7.41647 17.5 8.30012 17.5H16.9001C17.7838 17.5 18.5001 16.7837 18.5001 15.9V9.6C18.5001 8.71634 17.7838 8 16.9001 8H16.2616",
    stroke: "#16D5F2",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionChain);
export default __webpack_public_path__ + "static/media/action-chain.9beb13a35311b69a2c33c86485c552be.svg";
export { ForwardRef as ReactComponent };